import React from 'react';
import { Input } from 'reactstrap';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';

import './FormComponents.css';

export interface ICustomTextProps<T extends FieldValues> {
  control: Control<T, object>;
  fieldName: FieldPath<T>;
  label: string;
  placeholder?: string;
  readonly?: boolean;
  className?: string;
  rules?: Omit<
    RegisterOptions<T, FieldPath<T>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
}

export function ControlledTextArea<T extends FieldValues>({
  fieldName,
  control,
  label,
  placeholder,
  rules,
  readonly,
  className,
}: ICustomTextProps<T>) {
  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules || {}}
      render={({ field, fieldState, formState }) => {
        const isValid: boolean =
          !fieldState.invalid && (fieldState.isTouched || formState.isSubmitted) && !readonly;
        const isInvalid: boolean =
          fieldState.invalid && (fieldState.isTouched || formState.isSubmitted) && !readonly;
        return (
          <>
            <span>{label}</span>
            <Input
              className={className}
              readOnly={readonly}
              type="textarea"
              valid={isValid}
              invalid={isInvalid}
              {...field}
              value={field.value as string}
              placeholder={placeholder || ''}
              disabled={readonly}
            />
          </>
        );
      }}
    />
  );
}
